export class ZbRuta {
    SomId: number;
    Nombre: string;
    Descripcion: string;
    Puntos: string[];

    constructor(id: number, nombre: string, descripcion: string) {
        this.SomId = id;
        this.Nombre = nombre;
        this.Descripcion = descripcion;
    }
}
// just an interface for type safety.
export interface marker {
    lat: number;
    lng: number;
    label?: string;
    draggable: boolean;
  }
